export function renderXAxis(parentElem, axis, y) {

	parentElem.append('g')
		.attr('class', 'hw_panel_graph_x_axis')
		.attr('transform', `translate(0,${y})`)
		.call(axis);

}



// WEBPACK FOOTER //
// ./utils/panelgraph/functions/render-x-axis.js